<template>
  <div class="pt-4">
    <div class="px-2 pt-2">
      <v-expansion-panel v-for="(item, index) in acompanhamentos" :key="index" class="mb-3" @input="setLoteIdSelecionado(index)">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div class="d-flex justify-space-between">
              <div>
                <span class="header-item">{{ item.lote }}</span>
                <v-layout row class="az-inline-layout">
                  <div v-if="item.ehItem">
                    <span class="pa-3">|</span>
                    <v-tooltip top max-width=750>
                      <span slot="activator">{{ item.descricao | az-clip-text(50) }}</span>
                      <span>{{ item.descricao }}</span>
                    </v-tooltip>
                  </div>
                  <div v-if="item.ehModalidadeLeilao || !item.ehItem" class="pl-1">
                    <span class="pa-3">|</span>
                    <button class="blue--text inline text-decoration-underline" @click.stop="verItens(index)">
                      {{item.ehModalidadeLeilao ? 'ver detalhes' : 'ver itens'}}
                    </button>
                  </div>
                </v-layout>
              </div>
              <div class="text-md-right pr-2">
                <span>{{ item.titulo }}</span>
              </div>
            </div>
          </template>
          <acompanhamento-tabela
            class="pb-2"
            :acompanhamento-detalhes="acompanhamentoDetalhes[index]"
            :situacao="item.titulo"
            :licitacao-id="licitacaoId"
            :lote-id="item.loteId"
            :fase="item.loteFase"
            :ehMelhorTecnica="item.ehMelhorTecnica"
            :possui-vencedor="item.possuiVencedor"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <modal-ver-itens-grupo class="modal-ver-itens-grupo"
                           max-width="700"
                           ref="modalVerItensGrupo"
     />
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import AcompanhamentoTabela from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/AcompanhamentoTabela'
import ModalVerItensGrupo from '@/views/components/ModalVerItensGrupo'

export default {
    name: 'LicitacaoVisualizacaoAcompanhamento',
    components: {
        AcompanhamentoTabela,
        ModalVerItensGrupo,
    },
    data() {
        return {
            licitacaoId: null,
            acompanhamentos: [],
            acompanhamentoDetalhes: [],
            loteIdSelecionado: null,
        }
    },
    computed: {
        actionTypes() {
            return actionTypes
        },
    },
    async created() {
        this.setLicitacaoId()
        await this.buscarAcompanhamentos()
    },
    methods:{
        async buscarAcompanhamentos(){
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ACOMPANHAMENTO, this.licitacaoId)
            this.acompanhamentos = resultado
        },
        async buscarAcompanhamentosDetalhes(){
            if (this.loteIdSelecionado !== null) {
                const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ACOMPANHAMENTO_DETALHE,
                    {licitacaoId: this.licitacaoId, loteId: this.loteIdSelecionado})
                this.$set(this.acompanhamentoDetalhes, this.acompanhamentos.findIndex(item => item.loteId === this.loteIdSelecionado), resultado)
            }
        },
        setLoteIdSelecionado(index){
            this.loteIdSelecionado = this.acompanhamentos[index].loteId
            this.buscarAcompanhamentosDetalhes()
        },
        setLicitacaoId(){
            this.licitacaoId = Number(this.$route.params.id)
        },
        verItens(index){
            const acompanhamento = this.acompanhamentos[index]

            if (acompanhamento.ehModalidadeLeilao) {
                this.$router.push({
                    name: 'licitacaoVisualizacaoDetalhesLote',
                    params: {id: this.licitacaoId},
                    query: {loteId: acompanhamento.loteId}
                })
            }

            this.$refs.modalVerItensGrupo.open({acompanhamento})
        }
    }
}
</script>
<style lang="stylus">
.v-expansion-panel:has(.v-expansion-panel__container)
  .v-expansion-panel__header
    background-color #EBEBEB
    border: none !important

  .v-expansion-panel__body
    border: none !important

  .v-expansion-panel__container
    background-color #EBEBEB !important

.v-expansion-panel:has(.v-expansion-panel__container.v-expansion-panel__container--active)
  border-radius 5px !important

  .v-expansion-panel__header
    background-color #eae8e8
    border: none !important

    .header-item
      color: var(--v-primary-base) !important

  .v-expansion-panel__container
    background-color #fafafa !important

.text-decoration-underline
  text-decoration: underline

.az-inline-layout
  display: inline-flex
  flex: 0 0 auto

.az-cursor-pointer
  cursor: pointer

</style>